export default "__VITE_ASSET__DtZjtrCs__"